// // import React from 'react';

// // const About = () => {
// //   return (
// //     <section className="py-12 bg-[#edece8]">
// //       <div className="max-w-6xl mx-auto px-4">
// //         <div className="flex flex-col md:flex-row gap-8 items-center">
// //           <div className="w-full md:w-1/2 text-left">
// //             <h2 className="text-3xl font-bold mb-4">O nas</h2>
// //             <p className="text-lg leading-10">
// //             <p>Jeśli marzysz o wypoczynku nad morzem z rodziną, Kolorowe Domki to idealne miejsce! Już od 2013 roku zapewniamy niezapomnianą atmosferę naszym Gościom – zarówno najmłodszym, jak i starszym. Oferujemy komfortowe drewniane domki dla 4-6 osób oraz przestronne Apartamenty Kolorowe Domki dla 4-8 osób.</p>

// // <p>Nasze obiekty znajdują się w malowniczej Jastrzębiej Górze, w pobliżu Rozewia i jego latarni morskiej. Spokojna okolica sprzyja relaksowi, a bliskość plaży oraz tras pieszych i rowerowych gwarantuje aktywny wypoczynek. W okresie letnim organizujemy specjalne atrakcje: dzień z naleśnikami dla dzieci i wieczory z rybami dla dorosłych.</p>

// // <p>Gościom zapewniamy miejsce parkingowe oraz przestrzeń do zabawy i grillowania. Do plaży prowadzą wygodne zejścia – wybetonowane nr 20 oraz malownicze „Lisi Jar” nr 19.</p>

// // Zapraszamy na rodzinny wypoczynek nad morzem!

// // <p><b>Zapewniamy miejsca parkingowe dla naszych Gości w cenie wynajmu. </b></p>
// //             </p>
// //           </div>
// //           <div className="w-full md:w-1/2 flex flex-col gap-12">
// //              <img
// //               src="/images/aboutuspicture1.jpg"
// //               alt="O nas"
// //               className="rounded-lg shadow-md object-cover w-full h-auto"
// //             />
// //             <img
// //               src="/images/aboutuspicture2.jpg"
// //               alt="O nas"
// //               className="rounded-lg shadow-md object-cover w-full h-auto"
// //             />
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default About;

// // import React, { useState, useEffect } from 'react';

// // const About = () => {
// //   const [aboutData, setAboutData] = useState({
// //     title: "O nas",
// //     paragraphs: [
// //       "Jeśli marzysz o wypoczynku nad morzem z rodziną, Kolorowe Domki to idealne miejsce! Już od 2013 roku zapewniamy niezapomnianą atmosferę naszym Gościom – zarówno najmłodszym, jak i starszym. Oferujemy komfortowe drewniane domki dla 4-6 osób oraz przestronne Apartamenty Kolorowe Domki dla 4-8 osób.",
// //       "Nasze obiekty znajdują się w malowniczej Jastrzębiej Górze, w pobliżu Rozewia i jego latarni morskiej. Spokojna okolica sprzyja relaksowi, a bliskość plaży oraz tras pieszych i rowerowych gwarantuje aktywny wypoczynek. W okresie letnim organizujemy specjalne atrakcje: dzień z naleśnikami dla dzieci i wieczory z rybami dla dorosłych.",
// //       "Gościom zapewniamy miejsce parkingowe oraz przestrzeń do zabawy i grillowania. Do plaży prowadzą wygodne zejścia – wybetonowane nr 20 oraz malownicze „Lisi Jar” nr 19.",
// //       "Zapraszamy na rodzinny wypoczynek nad morzem!"
// //     ],
// //     boldText: "Zapewniamy miejsca parkingowe dla naszych Gości w cenie wynajmu.",
// //     images: [
// //       "/images/aboutuspicture1.jpg",
// //       "/images/aboutuspicture2.jpg"
// //     ]
// //   });

// //   useEffect(() => {
// //     const savedData = localStorage.getItem('aboutData');
// //     if (savedData) {
// //       setAboutData(JSON.parse(savedData));
// //     }
// //   }, []);

// //   return (
// //     <section className="py-12 bg-[#edece8]">
// //       <div className="max-w-6xl mx-auto px-4">
// //         <div className="flex flex-col md:flex-row gap-8 items-center">
// //           <div className="w-full md:w-1/2 text-left">
// //             <h2 className="text-3xl font-bold mb-4">{aboutData.title}</h2>
// //             <div className="text-lg leading-10">
// //               {aboutData.paragraphs.map((paragraph, index) => (
// //                 <p key={index}>{paragraph}</p>
// //               ))}
// //               <p><b>{aboutData.boldText}</b></p>
// //             </div>
// //           </div>
// //           <div className="w-full md:w-1/2 flex flex-col gap-12">
// //             {aboutData.images.map((image, index) => (
// //               <img
// //                 key={index}
// //                 src={image}
// //                 alt="O nas"
// //                 className="rounded-lg shadow-md object-cover w-full h-auto"
// //               />
// //             ))}
// //           </div>
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default About;

// import React, { useState, useEffect } from 'react';

// const About = () => {
//   const [aboutData, setAboutData] = useState({
//     title: "O nas",
//     titleStyle: { fontSize: "2.25rem", fontWeight: "bold" },
//     paragraphs: [
//       {
//         text: "Jeśli marzysz o wypoczynku nad morzem z rodziną, Kolorowe Domki to idealne miejsce! Już od 2013 roku zapewniamy niezapomnianą atmosferę naszym Gościom – zarówno najmłodszym, jak i starszym. Oferujemy komfortowe drewniane domki dla 4-6 osób oraz przestronne Apartamenty Kolorowe Domki dla 4-8 osób.",
//         style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
//       },
//       // ... pozostałe domyślne paragrafy
//     ],
//     boldText: {
//       text: "Zapewniamy miejsca parkingowe dla naszych Gości w cenie wynajmu.",
//       style: { fontSize: "1.125rem", fontWeight: "bold", fontStyle: "normal" }
//     },
//     images: [
//       "/images/aboutuspicture1.jpg",
//       "/images/aboutuspicture2.jpg"
//     ]
//   });

//   useEffect(() => {
//     const savedData = localStorage.getItem('aboutData');
//     if (savedData) {
//       setAboutData(JSON.parse(savedData));
//     }
//   }, []);

//   return (
//     <section className="py-12 bg-[#edece8]">
//       <div className="max-w-6xl mx-auto px-4">
//         <div className="flex flex-col md:flex-row gap-8 items-center">
//           <div className="w-full md:w-1/2 text-left">
//             <h2 className="text-3xl font-bold mb-4" style={aboutData.titleStyle}>
//               {aboutData.title}
//             </h2>
//             <div className="text-lg leading-10">
//               {aboutData.paragraphs.map((paragraph, index) => (
//                 <p key={index} style={paragraph.style}>{paragraph.text}</p>
//               ))}
//               <p style={aboutData.boldText.style}>
//                 <b>{aboutData.boldText.text}</b>
//               </p>
//             </div>
//           </div>
//           <div className="w-full md:w-1/2 flex flex-col gap-12">
//             {aboutData.images.map((image, index) => (
//               <img
//                 key={index}
//                 src={image}
//                 alt="O nas"
//                 className="rounded-lg shadow-md object-cover w-full h-auto"
//               />
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default About;

import React, { useState, useEffect } from 'react';

const About = () => {
  const [aboutData, setAboutData] = useState({
    title: "O nas",
    titleStyle: { fontSize: "2.25rem", fontWeight: "bold" },
    paragraphs: [
      {
        text: "Jeśli marzysz o wypoczynku nad morzem z rodziną, Kolorowe Domki to idealne miejsce! Już od 2013 roku zapewniamy niezapomnianą atmosferę naszym Gościom – zarówno najmłodszym, jak i starszym. Oferujemy komfortowe drewniane domki dla 4-6 osób oraz przestronne Apartamenty Kolorowe Domki dla 4-8 osób.",
        style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
      },
      {
        text: "Nasze obiekty znajdują się w malowniczej Jastrzębiej Górze, w pobliżu Rozewia i jego latarni morskiej. Spokojna okolica sprzyja relaksowi, a bliskość plaży oraz tras pieszych i rowerowych gwarantuje aktywny wypoczynek. W okresie letnim organizujemy specjalne atrakcje: dzień z naleśnikami dla dzieci i wieczory z rybami dla dorosłych.",
        style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
      },
      {
        text: "Gościom zapewniamy miejsce parkingowe oraz przestrzeń do zabawy i grillowania. Do plaży prowadzą wygodne zejścia – wybetonowane nr 20 oraz malownicze „Lisi Jar” nr 19.",
        style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
      },
      {
        text: "Zapraszamy na rodzinny wypoczynek nad morzem!",
        style: { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
      }
    ],
    boldText: {
      text: "Zapewniamy miejsca parkingowe dla naszych Gości w cenie wynajmu.",
      style: { fontSize: "1.125rem", fontWeight: "bold", fontStyle: "normal" }
    },
    images: [
      "/images/aboutuspicture1.jpg",
      "/images/aboutuspicture2.jpg"
    ]
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAboutData = async () => {
      try {
        setLoading(true);
        const response = await fetch('http://localhost/api/about.php');
        
        if (!response.ok) {
          throw new Error('Błąd podczas pobierania danych');
        }
        
        const data = await response.json();
        
        // Sprawdź czy serwer zwrócił poprawne dane
        if (data && !data.error) {
          // Funkcja migrująca dane dla kompatybilności
          const migratedData = migrateOldData(data);
          setAboutData(migratedData);
        } else {
          console.warn('Serwer zwrócił błąd, używam domyślnych danych');
        }
      } catch (error) {
        console.error('Błąd pobierania danych:', error);
        //setError('Nie udało się załadować danych. Wyświetlam domyślną zawartość.');
        // Używamy domyślnych danych w przypadku błędu
      } finally {
        setLoading(false);
      }
    };

    fetchAboutData();
  }, []);

  // Funkcja migrująca starą strukturę danych do nowej
  const migrateOldData = (oldData) => {
    // Jeśli dane są w starej formie (tylko tekst)
    if (typeof oldData === 'string' || Array.isArray(oldData)) {
      return aboutData; // Zwróć domyślne dane
    }
    
    // Jeśli dane są obiektem, upewnij się że mają właściwą strukturę
    if (oldData && typeof oldData === 'object') {
      const migratedData = { ...aboutData, ...oldData };
      
      // Upewnij się, że titleStyle istnieje
      if (!migratedData.titleStyle) {
        migratedData.titleStyle = { ...aboutData.titleStyle };
      }
      
      // Upewnij się, że paragraphs mają właściwą strukturę
      if (Array.isArray(migratedData.paragraphs)) {
        migratedData.paragraphs = migratedData.paragraphs.map((para, index) => {
          if (typeof para === 'string') {
            // Stara struktura - zamień na nową
            return {
              text: para,
              style: { ...aboutData.paragraphs[0]?.style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" } }
            };
          }
          // Nowa struktura, ale upewnij się, że style istnieje
          return {
            ...para,
            style: para.style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" }
          };
        });
      }
      
      // Upewnij się, że boldText ma właściwą strukturę
      if (migratedData.boldText && typeof migratedData.boldText === 'string') {
        // Stara struktura - zamień na nową
        migratedData.boldText = {
          text: migratedData.boldText,
          style: { ...aboutData.boldText.style }
        };
      } else if (migratedData.boldText && typeof migratedData.boldText === 'object') {
        // Nowa struktura, ale upewnij się, że style istnieje
        migratedData.boldText = {
          text: migratedData.boldText.text || "",
          style: migratedData.boldText.style || { ...aboutData.boldText.style }
        };
      }
      
      // Upewnij się, że images istnieje
      if (!migratedData.images || !Array.isArray(migratedData.images)) {
        migratedData.images = [...aboutData.images];
      }
      
      return migratedData;
    }
    
    return aboutData;
  };

  // Funkcja do bezpiecznego wyświetlania stylu
  const getSafeStyle = (style) => {
    return style || { fontSize: "1.125rem", fontWeight: "normal", fontStyle: "normal" };
  };

  if (loading) {
    return (
      <section className="py-12 bg-[#edece8]">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-12 bg-[#edece8]">
      <div className="max-w-6xl mx-auto px-4">
        {error && (
          <div className="mb-6 p-4 bg-yellow-100 border border-yellow-400 rounded-md text-yellow-700">
            {error}
          </div>
        )}
        
        <div className="flex flex-col md:flex-row gap-8 items-center">
          <div className="w-full md:w-1/2 text-left">
            <h2 className="text-3xl font-bold mb-4" style={getSafeStyle(aboutData.titleStyle)}>
              {aboutData.title || "O nas"}
            </h2>
            <div className="text-lg leading-10">
              {aboutData.paragraphs && aboutData.paragraphs.map((paragraph, index) => (
                <p key={index} style={getSafeStyle(paragraph.style)}>
                  {paragraph.text || ""}
                </p>
              ))}
              {aboutData.boldText && (
                <p style={getSafeStyle(aboutData.boldText.style)}>
                  <b>{aboutData.boldText.text || ""}</b>
                </p>
              )}
            </div>
          </div>
          <div className="w-full md:w-1/2 flex flex-col gap-12">
            {aboutData.images && aboutData.images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt="O nas"
                className="rounded-lg shadow-md object-cover w-full h-auto"
                onError={(e) => {
                  // Fallback dla błędów ładowania obrazków
                  e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtc2l6ZT0iMTIiIGR5PSIuM2VtIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjOTk5Ij5CxIVkIGxhdG93YW5pYSBvYnJhesSFa2E8L3RleHQ+PC9zdmc+';
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;